var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'cursor-pointer': _vm.canReact,
    flex: true,
    'flex-row': true,
    'items-center': _vm.isUsedInPostExpandedView,
    'items-end': !_vm.isUsedInPostExpandedView,
    'text-dark-text-200': !_vm.isPadletColorSchemeDark,
    'text-light-text-200': _vm.isPadletColorSchemeDark,
    'hover-hover:hover:text-dark-text-100': !_vm.isPadletColorSchemeDark,
    'hover-hover:hover:text-light-text-100': _vm.isPadletColorSchemeDark,
    'hover-hover:focus:text-grape-500': !_vm.isPadletColorSchemeDark,
    'hover-hover:focus:text-canary-500': _vm.isPadletColorSchemeDark,
    'hover-hover:active:text-grape-500': !_vm.isPadletColorSchemeDark,
    'hover-hover:active:text-canary-500': _vm.isPadletColorSchemeDark,
  },attrs:{"title":_vm.title},on:{"click":_vm.startReacting}},[_c('div',{staticClass:"flex flex-row"},[(_vm.reactionCount === 0)?_c('OzIcon',{attrs:{"size":_vm.iconSize,"name":"star_outline"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.fullStarRange),function(fullStar){return _c('OzIcon',{key:fullStar,class:_vm.avgRatingStarColorClass,attrs:{"size":_vm.iconSize,"name":"star_filled"}})}),_vm._v(" "),(_vm.xHalfStar)?_c('OzIcon',{class:_vm.avgRatingStarColorClass,attrs:{"name":"star_half","size":_vm.iconSize}}):_vm._e()],2),_vm._v(" "),(_vm.reactionCount > 0)?_c('span',{key:"ratingCount",class:[_vm.isUsedInPostExpandedView ? 'text-body-small' : 'text-12-16', 'font-sans', !_vm.xHalfStar && 'ms-1']},[_vm._v("\n    ("+_vm._s(_vm.reactionCount)+")\n  ")]):_vm._e(),_vm._v(" "),(_vm.canReact && !_vm.myReactionId)?_c('span',{key:"rateButton",class:[
      _vm.isUsedInPostExpandedView
        ? _vm.isSmallerThanTabletPortrait
          ? 'text-body-small'
          : 'text-body-extra-small'
        : 'text-12-16',
      'font-sans',
      'font-semibold',
      'ms-1' ],attrs:{"role":"button"}},[_vm._v("\n    "+_vm._s(_vm.__('Rate'))+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }